import http from 'axios';


// const apiPrefix = '/wp-json/wp/v2';
const apiPrefix = '/wordpress/wp-json/wp/v2';
const instance = http.create();

instance.interceptors.request.use(
  config => {
    config.url = apiPrefix + config.url;
    config.headers.common['Content-Type'] = 'application/json; charset=UTF-8';
    console.log('config', config.headers);
    return config;
  },
  err => {

  }
);

instance.interceptors.response.use(
  (res) => {
    const { data, config } = res;
    if (res.status === 200) {
      return data;
    }
    console.error('request fail test', res);

    return Promise.reject(res);

  },
  (err) => {
    return Promise.reject(err);
  }
);

export { instance as http };